import { render, staticRenderFns } from "./simple-echarts.vue?vue&type=template&id=15d751d3&scoped=true&"
import script from "./simple-echarts.vue?vue&type=script&lang=js&"
export * from "./simple-echarts.vue?vue&type=script&lang=js&"
import style0 from "./simple-echarts.vue?vue&type=style&index=0&id=15d751d3&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d751d3",
  null
  
)

export default component.exports